import axios from "axios";

import { to } from "../../helpers/api";

export const homeStats = {
  getNestStats: () => {
    return axios.get(to("stat/home"));
  },
};
